/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddOutputCommandResult } from '../../models/add-output-command-result';

export interface ApiMeetingsAddOutputPut$Params {
      body?: {
'MeetingId'?: string;
'Output'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiMeetingsAddOutputPut(http: HttpClient, rootUrl: string, params?: ApiMeetingsAddOutputPut$Params, context?: HttpContext): Observable<StrictHttpResponse<AddOutputCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsAddOutputPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddOutputCommandResult>;
    })
  );
}

apiMeetingsAddOutputPut.PATH = '/api/Meetings/AddOutput';
